export interface IQuickEditBaseModel {
    formId: string;
    name: string;
}

export class QuickEditBaseModel implements IQuickEditBaseModel {
    public formId: string;
    public name: string;

    // tslint:disable-next-line: unified-signatures
    constructor(obj?: IQuickEditBaseModel);
    constructor(obj?: any) {
        this.formId = obj && obj.formId || '';
        this.name = obj && obj.name || '';
    }
}
